import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getAttributeType, getModelName } from '../../utils/models'
import { getApi, getValueAttribute, getLabelAttribute } from '../../utils/apis'
import Title from '../Title'
import _ from 'lodash'
import moment from 'moment'
import custom from '../../config/custom'

class Format extends Component {

    constructor(props) {
        super(props)

        this.state = {
            value: null
        }
    }

    componentWillMount() {
        this.format()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.model !== this.props.model
            || prevProps.attribute !== this.props.attribute
            || prevProps.value !== this.props.value
            || prevProps.apis.customer !== this.props.apis.customer
            || prevProps.apis.supplier !== this.props.apis.supplier
            || prevProps.apis.sbu !== this.props.apis.sbu
            || prevProps.apis.location !== this.props.apis.location) {
            this.format()
        }
    }

    type() {
        return getAttributeType(this.props.model, this.props.attribute)
    }

    async format() {
        if (this.props.value === null ||
            this.props.value === undefined) {
            this.setState({ value: 'N/A' })
            return
        }

        let value = null
        let model = null

        switch (this.type()) {
            case 'file':
                if (_.isArray(this.props.value) &&
                    this.props.value.length) {

                    const firstFile = _.first(this.props.value)

                    if (_.includes(firstFile.type, 'image')) {
                        value = (
                            <div style={{
                                backgroundSize: 'cover',
                                backgroundImage: `url('${custom.baseUrl}/files/${firstFile.id}')`,
                                width: 64,
                                height: 64,
                                borderRadius: '50%',
                                overflow: 'hidden',
                                border: '1px solid rgba(0,0,0,0.2)'
                            }} />
                        )
                    } else {
                        value = _.join(_.map(this.props.value, 'name'), ', ')
                    }

                } else {
                    value = 'N/A'
                }
                this.setState({ value })
                break

            case 'number':
                this.setState({ value: this.props.value })
                break

            case 'boolean':
                this.setState({ value: this.props.value ? 'Yes' : 'No' })
                break

            case 'date':
                if (this.props.value) {
                    value = moment(this.props.value).format('LL')
                } else {
                    value = 'N/A'
                }
                this.setState({ value })
                break

            case 'datetime':
                if (this.props.value) {
                    value = moment(this.props.value).format('LLL')
                } else {
                    value = 'N/A'
                }
                this.setState({ value })
                break

            case 'model':
                model = getModelName(this.props.model, this.props.attribute)
                value = <Title model={model} value={this.props.value} />
                this.setState({ value })
                break

            case 'collection':
                model = getModelName(this.props.model, this.props.attribute)
                value = <Title model={model} value={this.props.value} />
                this.setState({ value })
                break

            case 'api':
                const _value = this.props.value || 'N/A'

                this.setState({ value: _value }, () => {
                    const api = getApi(this.props.model, this.props.attribute)

                    if (this.props.apis.hasOwnProperty(api)) {
                        const valueAttribute = getValueAttribute(api)
                        const labelAttribute = getLabelAttribute(api)
                        let value = null

                        value = _.find(this.props.apis[api], { [valueAttribute]: this.props.value })

                        if (value) {
                            value = value[labelAttribute]
                        }

                        this.setState({ value: (value || _value) })
                    }
                })
                break

            case 'text':
                this.setState({ value: (this.props.value || 'N/A') })
                break

            default:
                this.setState({ value: (this.props.value || 'N/A') })
                break
        }
    }

    render() {
        return this.state.value
    }

}

Format.propTypes = {
    model: PropTypes.string.isRequired,
    attribute: PropTypes.string.isRequired,
    value: PropTypes.any,
    options: PropTypes.object,
}

const mapStateToProps = state => ({
    apis: state.apis
})

export default connect(mapStateToProps)(Format)


// WEBPACK FOOTER //
// ./src/containers/Format/index.js